import crypto from 'crypto'
import { getLiveConfigurationCache } from './configuration/configurationCache'

const selected = {
  // note: example structure
  // analyticsProviderAnonymous: {
  //   bVariantProbability: null, // keep track of the last used probability to avoid recalculation
  //   cohort: null,
  //   assignmentKey: null, // the key used for assignment (e.g. user ID or session ID)
  // },
  // analyticsProviderUser: {
  //   bVariantProbability: null, // keep track of the last used probability to avoid recalculation
  //   cohort: null,
  //   assignmentKey: null, // the key used for assignment (e.g. user ID or session ID)
  // },
  mediaService: {
    bVariantProbability: null, // keep track of the last used probability to avoid recalculation
    cohort: null,
  },
}

export function computeAOrBVariant(assignmentKey, bVariantProbability) {
  if (!assignmentKey) {
    return null
  }

  const bProbability = parseInt(bVariantProbability, 10)

  if (Number.isNaN(bProbability) || bProbability <= 0) {
    return 'A'
  }

  if (bProbability >= 100) {
    return 'B'
  }

  const hash = crypto
    .createHash('sha256')
    .update(assignmentKey)
    .digest('hex')

  // take first 8 hex chars -> 32-bit number
  const num = parseInt(hash.slice(0, 8), 16)
  const bucket = num % 100 // 0–99

  console.log(
    'bVariantProbability:', bVariantProbability,
    'assignmentKey:', assignmentKey,
    'hash:', hash,
    'bucket:', bucket,
  )

  return bucket < bProbability ? 'B' : 'A'
}

export function getAOrBVariant(experimentName, assignmentKey, bVariantProbability) {
  if (!assignmentKey) return 'A'

  const cache = selected[experimentName] || {}
  if (
    cache.bVariantProbability !== bVariantProbability ||
    cache.assignmentKey !== assignmentKey ||
    !cache.cohort
  ) {
    if (!selected[experimentName]) {
      selected[experimentName] = {}
    }
    selected[experimentName].bVariantProbability = bVariantProbability
    selected[experimentName].assignmentKey = assignmentKey
    selected[experimentName].cohort = computeAOrBVariant(assignmentKey, bVariantProbability)
  }

  return selected[experimentName].cohort
}

export function shouldPresentBFeature(experimentName, assignmentKey, bVariantProbability) {
  return getAOrBVariant(experimentName, assignmentKey, bVariantProbability) === 'B'
}

function chooseAOrBVariantFromLocalStorageUser(experimentName, bVariantProbability) {
  const session = JSON.parse(localStorage.getItem('ls.session'))
  const userId = session?.user
  return getAOrBVariant(experimentName, userId, bVariantProbability)
}

export function shouldPresentBFeatureForUser(bVariantProbability, experimentName) {
  return chooseAOrBVariantFromLocalStorageUser(experimentName, bVariantProbability) === 'B'
}

export function shouldPresentMediaService() {
  const { mediaServiceUseProbability } = getLiveConfigurationCache() || {}
  // if default is 100, always use 100. otherwise use the configuration value if available
  const probability = process.env.REACT_APP_MEDIASERVICE_DEFAULT_USE_PROBABILITY === '100' ?
    '100' :
    mediaServiceUseProbability ?? process.env.REACT_APP_MEDIASERVICE_DEFAULT_USE_PROBABILITY
  return shouldPresentBFeatureForUser(probability, 'mediaService')
}
